/**
 * 产品要求下一个整点，如4:14 => 5:00
 * @returns {number}
 */
export function getNextHourStart({ tomorrow = false } = {}) {
  const now = new Date();
  now.setMinutes(60); // 进位到下一个整点
  now.setSeconds(0);
  now.setMilliseconds(0);
  if (tomorrow) {
    return now.getTime() + 24 * 60 * 60 * 1000;
  }
  return now.getTime();
}